export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}scorm/scorm`;
    const url = `${baseUrl}`;

    return $resource(url, null, {
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Scorm/index.js